import { dataEditSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconEditSolid = /*#__PURE__*/createIcon(dataEditSolid)
export default IconEditSolid
